import { render } from "./demo-day-company-dashboard.vue?vue&type=template&id=684c4ae3"
import script from "./demo-day-company-dashboard.vue?vue&type=script&lang=js"
export * from "./demo-day-company-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__